import { useMemo } from 'react';

import type { GameReturnDto } from '@skillarea/lib-shared';
import { useTranslation } from 'react-i18next';

import { resolveLocalizedGameContent } from '~/lib/gameLocale';

export type TLocalizedGameContent = Pick<
  GameReturnDto,
  'name' | 'description' | 'rules'
>;

type TGameLocaleSource = Pick<
  GameReturnDto,
  'slug' | 'name' | 'description' | 'rules'
>;

export function useLocalizedGame(
  game: TGameLocaleSource,
): TLocalizedGameContent {
  const { i18n } = useTranslation();

  return useMemo(
    () => resolveLocalizedGameContent(game, i18n.language),
    [game.description, game.name, game.rules, game.slug, i18n.language],
  );
}

export function useLocalizedGameName(
  slug: string,
  fallbackName: string,
): string {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const name = resolveLocalizedGameContent(
      { slug, name: fallbackName, description: '', rules: '' },
      i18n.language,
    ).name;

    return name.replace(/\n/g, ' ');
  }, [slug, fallbackName, i18n.language]);
}
